import React, { useState } from 'react';
import './CreateGroupDialog.scss';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useCreateProjectGroup } from '../../../../shared/hooks/projects/UseProjectGroups';

const GROUP_COLORS = ['#4A90D9', '#E74C3C', '#27AE60', '#F39C12', '#8E44AD', '#1ABC9C', '#E67E22', '#3498DB'];

interface CreateGroupDialogProps {
  visible: boolean;
  onHide: () => void;
}

const CreateGroupDialog: React.FC<CreateGroupDialogProps> = ({ visible, onHide }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [selectedColor, setSelectedColor] = useState<string>(GROUP_COLORS[0]);
  const { mutate: createGroup, isPending } = useCreateProjectGroup();

  const handleCreate = () => {
    const trimmed = name.trim();
    if (!trimmed) return;

    createGroup(
      { name: trimmed, color: selectedColor },
      {
        onSuccess: () => {
          setName('');
          setSelectedColor(GROUP_COLORS[0]);
          onHide();
        },
      }
    );
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleCreate();
  };

  const footer = (
    <Button
      className="btn btn--primary"
      label={t('create')}
      onClick={handleCreate}
      disabled={!name.trim() || isPending}
    />
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t('createGroup')}
      footer={footer}
      className="dialog-box create-group-dialog"
      draggable={false}
    >
      <div className="create-group-dialog__content">
        <div className="create-group-dialog__field">
          <label className="create-group-dialog__label">{t('groupName')}</label>
          <InputText
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={t('groupNamePlaceholder')}
            autoFocus
            className="create-group-dialog__input"
          />
        </div>
        <div className="create-group-dialog__field">
          <div className="create-group-dialog__colors">
            {GROUP_COLORS.map((color) => (
              <button
                key={color}
                className={`create-group-dialog__color-btn${selectedColor === color ? ' create-group-dialog__color-btn--active' : ''}`}
                style={{ backgroundColor: color }}
                onClick={() => setSelectedColor(color)}
                type="button"
                aria-label={color}
              />
            ))}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default CreateGroupDialog;
